<rp-card>
  <div class="header-wrapper" [class.clickable]="!!promoUri()" cardHeader (click)="onPreview()">
    <img [rpLazyLoadImage]="image()" size="m" alt="Preview" />
  </div>
  <div cardContent class="content-wrapper">
    <span class="identification" (click)="titleClickAction.emit()">{{ 'general.id' | translate }}: {{ id() }}</span>
    <span class="name">{{ name() }}</span>
    <span>{{ 'general.language' | translate }}</span>
  </div>

  <rp-button fullWidth fullHeight cardActions (click)="tileAction.emit()">
    {{ buttonName() }}
  </rp-button>
</rp-card>
